<template>
    <div class="cascader" v-loading="loading">
        <div class="content_box">
            <div>
                <div class="transfer-head">
                    <p style="font-weight: 700; font-size: 14px;">可选择备注</p>
                    <el-button :disabled="!options.length" type="text" size="small" @click="allSelectOptions">全部选择</el-button>
                    <p style="color: #909399;">
                        {{ options.length ? options.length : 0 }}
                    </p>
                </div>
                <el-scrollbar>
                    <ul v-if="options.length">
                        <li v-for="(item, index) in options" :key="item.value" @click="getBrandTypeData(item, index)">
                            <div>
                                <span class="text_box">{{ item.remark }}</span>
                            </div>
                            <i class="el-icon-right"></i>
                        </li>
                    </ul>
                </el-scrollbar>
            </div>
            <div>
                <div class="transfer-head">
                    <p style="font-weight: 700; font-size: 14px;">已选择备注</p>
                    <el-button :disabled="!brandTypeDataActives.length" type="text" size="small" @click="cancelSelectOptions">取消全部选择</el-button>
                    <p style="color: #909399;">
                        {{ brandTypeDataActives.length ? brandTypeDataActives.length : 0 }}
                    </p>
                </div>
                <el-scrollbar>
                    <ul v-if="brandTypeDataActives.length">
                        <li v-for="(item, index) in brandTypeDataActives" :key="item.value"
                            @click="brandTypeClick(item, index)">
                            <div>
                                <span class="text_box">{{ item.remark }}</span>
                            </div>
                            <i class="el-icon-back"></i>
                        </li>
                    </ul>
                    <div v-else class="is-empty">
                        <span>暂无数据</span>
                    </div>
                </el-scrollbar>
            </div>
        </div>
        <div class="handel_box">
            <!-- <el-button size="small">取 消</el-button> -->
            <el-button type="primary" size="small" @click="submitHandel">确 定</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: "remarks",
    data() {
        return {
            loading: true,
            // 左侧数据
            options: [],
            // 右侧
            brandTypeDataActives: [],
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {
            this.$post('/erpnew/account/c/reada46ceb/recordRemarkController/recordRemarkList.html').then((res) => {
                this.loading = false
                let data = res.data
                this.options = data.data.remarkAll
                this.brandTypeDataActives = data.data.remark
                this.options = this.options.filter(item1 => !this.brandTypeDataActives.some(item2 => item2.remark === item1.remark))
            })
        },
        // 左侧 单行选中后 删除左侧当条， 添加到右侧
        getBrandTypeData(row, index) {
            this.options.splice(index, 1)
            this.brandTypeDataActives.push(row)
        },
        // 右侧同上
        brandTypeClick(row, index) {
            this.brandTypeDataActives.splice(index, 1)
            this.options.push(row)
        },
        // 左侧选择全部时，合并数组到右侧，并清空左侧
        allSelectOptions() {
            this.brandTypeDataActives = [...this.brandTypeDataActives, ...this.options]
            this.options = []
        },
        // 右侧‘取消全部选择’， 合并数组到左侧，并清空右侧
        cancelSelectOptions() {
            this.options = [...this.options, ...this.brandTypeDataActives]
            this.brandTypeDataActives = []
        },
        // 提交按钮
        submitHandel() {
            this.$post('/erpnew/account/c/reada46ceb/recordRemarkController/updateRecordRemark.html', {remark: this.brandTypeDataActives}).then((res) => {
                if(res.data.message === 'success') {
                    this.$message.success('保存成功')
                    this.getData()
                } else {
                    this.$message.error('网络错误请稍后重试')
                }

            })
        }
    }
};
</script>
<style lang="less" scoped>
.cascader {
    padding: 20px;
    height: calc(100% - 40px);

    >.content_box {
        display: flex;
        justify-content: space-between;
        height: 80%;
        margin-bottom: 20px;

        >div {
            width: 48%;
            border: solid 1px #e4e7ed;
        }
    }

    >.handel_box {
        display: flex;
        justify-content: center;
    }

    ::v-deep .el-scrollbar {
        width: 100%;
        height: calc(100% - 40px);

        &:not(:first-child) {
            // border: solid 1px #e4e7ed;
        }

        .el-scrollbar__wrap {
            overflow-x: hidden;

            .el-scrollbar__view {
                height: 97%;

                ul {
                    padding: 6px 0;
                    height: calc(100% - 40px);
                    overflow-x: auto;

                    li {
                        border-bottom: solid 1px #e4e7ed;
                        padding: 0 20px 0 6px;
                        cursor: pointer;
                        height: 34px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        &:hover {
                            background-color: #f5f7fa;

                            i {
                                display: block;
                            }
                        }

                        >div {
                            width: 93%;
                        }

                        i {
                            display: none;
                        }
                    }

                    .active {
                        color: #409eff;
                        font-weight: 700;
                    }

                    .text_box {
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        display: inline-block;
                        width: 100%;
                    }
                }

                .is-empty {
                    height: calc(100% - 40px);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #c0c4cc;
                }
            }
        }
    }
}

.transfer-head {
    height: 40px;
    line-height: 40px;
    background: #f5f7fa;
    margin: 0;
    padding: 0 15px;
    border-bottom: 1px solid #ebeef5;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}</style>
